import type { IntegrationBusinessUnit } from 'api';

import { BusinessUnitCard } from './BusinessUnitCard';
import { BUSINESS_UNITS_GRID_TEST_ID } from './constants';

type BusinessUnitsGridProps = {
  businessUnits: IntegrationBusinessUnit[];
};

export const BusinessUnitsGrid = ({
  businessUnits
}: BusinessUnitsGridProps) => (
  <div
    data-testid={BUSINESS_UNITS_GRID_TEST_ID}
    className="flex w-full flex-wrap gap-6"
  >
    {businessUnits.map((businessUnit) => (
      <BusinessUnitCard key={businessUnit.uuid} businessUnit={businessUnit} />
    ))}
  </div>
);
